import { profilePath } from "@travily/routes";
import type Family from "@travily/types/models/Family";
import type { FamilyIdentityTrait } from "@travily/types/models/Family";
import { Card, CardImage, CardTitle } from "@ui/components/Card";
import type { CardTheme } from "@ui/types/card";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";

export interface FamilyCardProps {
  className?: string;
  family: Family & FamilyIdentityTrait;
  /** Visual treatment: "editorial" for spacious layouts, "compact" for dense grids. */
  theme?: CardTheme;
}

export function FamilyCard({ className, family, theme = "editorial" }: FamilyCardProps) {
  return (
    <Card className={className ?? "gap-2 lg:gap-2.5"} href={profilePath(family.handle)} linkLabel={family.display_name}>
      <CardImage
        alt={family.display_name}
        fallback={
          <AccountAvatar
            account={{ profile_type: "Family", initial: family.initial }}
            className="size-full rounded-none text-6xl"
          />
        }
        image={family.avatar}
        overlayInset="sm"
      />
      <CardTitle theme={theme}>{family.display_name}</CardTitle>
    </Card>
  );
}
